import { createSlice } from '@reduxjs/toolkit';
import api from '../utils/httpClient';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getClassSessionPatient = createAsyncThunk(
	'accountClassSessionPatients/getClassSessionPatient',
	async ( sessionId: string ) => {
		console.log('getClassSessionPatient params', sessionId);
		const response = await api.get(
		 `class_session/${sessionId}/participants`, //params,
		{ timeout: 30000 }
		);
		// .then(response => {
		// 	console.log('getClassSessionPatient response', response);
		// 	return response.data;
		// })
		// .catch(error => {
		// 	console.log('getClassSessionPatient response error', error);
		// 	console.log('getClassSessionPatient response error', error.response.status);
		// 	if (error.response.status == 404){
		// 		throw new Error(`Not found`);
		// 	}
		// });
		console.log('getClassSessionPatient response', response);
		return response.data;
	}
);

export const getClassSessionPatientDevice = createAsyncThunk(
	'accountClassSessionPatients/getClassSessionPatientDevice',
	async ( sessionId: string ) => {
		console.log('getClassSessionPatientDevice params', sessionId);
		const response = await api.get(
		 `class_session/${sessionId}/participants_devices`, //params,
		{ timeout: 30000 }
		);
		console.log('getClassSessionPatientDevice response', response);
		return response.data;
	}
);

const initialState: {
	status: string;
	error: string;
	data: any;
} = {
	status: '',
	error: '',
	data: {
		
	},
};

const classSessionPatientSlice = createSlice({
	name: 'classSessionPatient',
	initialState: initialState,
	reducers: {
		classsSessionPatientSliceClean(state, action) {
			console.log('classsSessionPatientSliceClean', action);
			state.data = {};
			state.data.pending = false;
			state.data.complete = false;
			state.data.error = '';
		},
	},

  	extraReducers: (builder) => {
		//getClassSessionPatient
		builder.addCase(getClassSessionPatient.pending, (state) => {
			console.log('getClassSessionPatient.pending');
			state.data = {};
			state.data.pending = true;
			state.data.complete = false;
			state.data.error = '';
		});
		builder.addCase(getClassSessionPatient.fulfilled, (state, action) => {
			console.log('getClassSessionPatient.fulfilled ', action);
			state.data.pending = false;
			state.data.complete = true;
			state.data = Object.assign(state.data, action.payload);
		});
		builder.addCase(getClassSessionPatient.rejected, (state, action) => {
			console.log('getClassSessionPatient.rejected action', action);
			console.log( 'getClassSessionPatient.rejected action payload', action.payload);
			state.data.pending = false;
			state.data.complete = false;

			state.data.error = action.error ? action.error.message! : '';
		});

		//getClassSessionPatientDevice
		builder.addCase(getClassSessionPatientDevice.pending, (state) => {
			console.log('getClassSessionPatientDevice.pending');
			state.data = {};
			state.data.pending = true;
			state.data.complete = false;
			state.data.error = '';
		});
		builder.addCase(getClassSessionPatientDevice.fulfilled, (state, action) => {
			console.log('getClassSessionPatientDevice.fulfilled', action);
			state.data.pending = false;
			state.data.complete = true;
			state.data = Object.assign(state.data, {patients : action.payload});
		});
		builder.addCase(getClassSessionPatientDevice.rejected, (state, action) => {
			console.log('getClassSessionPatientDevice.rejected action', action);
			console.log( 'getClassSessionPatientDevice.rejected action payload', action.payload);
			state.data.pending = false;
			state.data.complete = false;

			state.data.error = action.error ? action.error.message! : '';
		});

  	},
});

export const { classsSessionPatientSliceClean } = classSessionPatientSlice.actions;
export default classSessionPatientSlice;
